import LinkCell from '@isceco/widget-library2/basic-elements/List/cell/LinkCell.js';

export default class PhoneCell extends LinkCell {
  constructor() {
    super({
      url: row => `tel:${row.value}`,
      icon: 'phone alternate'
    })
  }
}
